import { render, staticRenderFns } from "./rating-stars.vue?vue&type=template&id=2702df9a"
import script from "./rating-stars.vue?vue&type=script&lang=ts"
export * from "./rating-stars.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports